import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  OsVersionData,
  OsVersionsData,
} from "app/shared";
import { OsVersionConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";

@Component({
  selector: "os-version-counts-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class OsVersionCountsChartComponent
  extends BaseChartLogic<OsVersionConfig, OsVersionsData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      OsVersionConfig,
      _ngZone
    );
    this.handleDataSubscription(this.analyticsService.osVersionDataChange);
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: OsVersionData): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    //this.addOsTypeToFilterSettings(); //DO NOT ADD OS TYPE TO FILTER SETTINGS
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
  }

  refreshData(): void {
    this.analyticsService.getOsVersionData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
